import { mapState } from 'vuex';
export default {
  name: 'TwinTreeview',
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    label: {
      type: String,
      required: true
    },
    selectOptions: {
      type: Array,
      default: () => []
    },
    canAddRule: {
      type: Boolean,
      default: false
    },
    dense: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedTwin: null
    };
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled'])
  },
  methods: {
    handleTwinSelected(twin) {
      this.selectedTwin = twin;
      this.$emit('input', twin ? twin.id : null);
    },
    getSelectedTwinTitle() {
      return this.selectedTwin ? this.selectedTwin.title : null;
    }
  }
};